"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var _1 = require("./");
var router_1 = require("@angular/router");
var ShortPathGameGuardService = (function () {
    function ShortPathGameGuardService(router, localizationService) {
        this.router = router;
        this.localizationService = localizationService;
        this.currentLang = this.localizationService.currentLang;
        this.rootUrl = this.localizationService.getRootUrl();
    }
    ShortPathGameGuardService.prototype.canActivate = function (route) {
        if (route.params.levelId === 'notfound') {
            this.router.navigate([this.currentLang + '/game/packs']);
        }
        else if (route.url.join('/').indexOf('level') !== -1) {
            this.router.navigate([this.currentLang + '/' + route.url.join('/')]);
        }
        else {
            this.router.navigate([this.currentLang + this.rootUrl]);
        }
        return false;
    };
    return ShortPathGameGuardService;
}());
ShortPathGameGuardService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [router_1.Router,
        _1.LocalizationService])
], ShortPathGameGuardService);
exports.ShortPathGameGuardService = ShortPathGameGuardService;



//////////////////
// WEBPACK FOOTER
// ./src/services/short-path-game-guard.service.ts
// module id = 263
// module chunks = 0